export default {
    getAll(searchTerms) {
        let dto = {
            UserType: searchTerms.UserType.Value,
            SearchText: searchTerms.SearchText,
            EntityID: searchTerms.EntityID,
            IncludeInactive: searchTerms.IncludeInactive,
            PageNumber: searchTerms.PageNumber,
            PageRows: searchTerms.PageRows,
            SortByColumn: searchTerms.SortByColumn,
            SortDirection: searchTerms.SortDirection
        }

        if (!dto.EntityID) {
            dto.EntityID = -1;
        }
        
        return DMUtils.http({
            method: 'POST',
            url: '/User/GetAll',
            data: dto,
        });
    },
    getByID(userID, userType) {
        return DMUtils.http({
            method: 'POST',
            url: '/User/GetByID',
            data: { 
                UserID : userID, 
                UserType : userType, 
            },
        });
    },
    autoComplete(searchText) {
        if (!searchText) {
            searchText = '';
        }

        return DMUtils.http({
            method: 'GET',
            url: '/User/Autocomplete',
            params: { SearchText: searchText }
        }, true);
    },
    create(user) {
        let dto = {
            Email: user.Email,
            FirstName: user.FirstName,
            LastName: user.LastName,
            IsActive: user.IsActive,
            UserType: user.UserType.Value,
            EntityRoles: user.EntityRoles,
        }
        
        return DMUtils.http({
            method: 'POST',
            url: '/User/Create',
            data: dto
        });
    },
    update(user) {
        let dto = {
            UserID: user.UserID,
            Email: user.Email,
            FirstName: user.FirstName,
            LastName: user.LastName,
            IsActive: user.IsActive,
            UserType: user.UserType.Value,
            EntityRoles: user.EntityRoles,
            RowVersion: user.RowVersion,
        }
        
        return DMUtils.http({
            method: 'POST',
            url: '/User/Update',
            data: dto,
        });
    },
    getTypes() {
        return DMUtils.http({
            method: 'GET',
            url: '/User/GetTypes',
        }, true);
    },
    getRoleOptions(userType) {
        return DMUtils.http({
            method: 'GET',
            url: '/Role/GetAllDropdown',
            params: { UserType: userType }
        });
    },
    getProfile(userID) {
        return DMUtils.http({
            method: 'GET',
            url: '/User/GetProfile',
            params: { UserID: userID }
        });
    },
    updateProfile(dto) {
        if (!dto.Title) {
            dto.Title = '';
        }

        if (!dto.Organization) {
            dto.Organization = '';
        }
        
        return DMUtils.http({
            method: 'POST',
            url: '/User/UpdateProfile',
            data: dto
        });
    },
    updatePassword(dto) {
        return DMUtils.http({
            method: 'POST',
            url: '/Auth/UpdatePassword',
            data: dto,
        });
    },  
}